import { ArrowLeft, Download, Settings, Share2, Upload } from 'lucide-react'
import { IconButton } from '../ui/IconButton'
import { SearchInput } from '../ui/SearchInput'
import { ViewToggle } from '../ui/ViewToggle'
import { TooltipProvider } from '@/components/ui/Tooltip'
import type { ViewMode } from './hooks/usePlaybookEditorState'

interface PlaybookEditorHeaderProps {
	playbookName: string
	teamName?: string
	searchQuery: string
	viewMode: ViewMode
	selectedPlayCount: number
	onBack?: () => void
	onSearchChange: (query: string) => void
	onViewModeChange: (mode: ViewMode) => void
	onImport: () => void
	onExport: () => void
	onShare: () => void
	onSettings: () => void
}

export function PlaybookEditorHeader({
	playbookName,
	teamName,
	searchQuery,
	viewMode,
	selectedPlayCount,
	onBack,
	onSearchChange,
	onViewModeChange,
	onImport,
	onExport,
	onShare,
	onSettings,
}: PlaybookEditorHeaderProps) {
	const exportTitle = selectedPlayCount > 0
		? `Export ${selectedPlayCount} selected`
		: 'Export All'

	return (
		<div className="playbook-editor-header">
			<div className="playbook-editor-header-content">
				<div className="playbook-editor-header-left">
					<TooltipProvider>
						<IconButton
							icon={ArrowLeft}
							tooltip="Back to Playbooks"
							onClick={onBack}
							variant="ghost"
						/>
					</TooltipProvider>
					<div>
						<div className="playbook-editor-title-row">
							<h1>{playbookName}</h1>
							{teamName && (
								<span className="playbook-editor-team-name">
									{teamName}
								</span>
							)}
						</div>
					</div>
					<div className="playbook-editor-header-divider" />
					<SearchInput
						value={searchQuery}
						onChange={onSearchChange}
						placeholder="Search plays, formations, labels..."
						className="playbook-editor-search-input"
					/>
				</div>

				<div className="playbook-editor-header-right">
					<TooltipProvider>
						<IconButton
							icon={Upload}
							tooltip="Import Plays"
							onClick={onImport}
							variant="ghost"
						/>
						<IconButton
							icon={Download}
							tooltip={exportTitle}
							onClick={onExport}
							variant="ghost"
						/>
						<div className="playbook-editor-header-divider-small" />
						<IconButton
							icon={Share2}
							tooltip="Share"
							onClick={onShare}
							variant="ghost"
						/>
						<div className="playbook-editor-header-divider-small" />
						<ViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
						<div className="playbook-editor-header-divider-small" />
						<IconButton
							icon={Settings}
							tooltip="Settings"
							onClick={onSettings}
							variant="ghost"
						/>
					</TooltipProvider>
				</div>
			</div>
		</div>
	)
}
